module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gjtah"))).then(() => parcelRequire('d0iPb'));